import { Component, input, output } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { FileSizePipe, SharedModule, UploadFilesModule, UploadFileStatus } from '@aiwyn/shared';
import { FileUploadJobItemComponent } from '../../../client-requests/containers/client-request-details/client-request-panel/components/file-upload-job-item/file-upload-job-item.component';
import { UploadDataReferenceRequestLink } from '@aiwyn/shared';
import { MatError } from '@angular/material/form-field';

@Component({
  selector: 'app-request-files-upload',
  standalone: true,
  imports: [UploadFilesModule, FileUploadJobItemComponent, SharedModule, FileSizePipe, ReactiveFormsModule, MatError],
  templateUrl: './request-files-upload.component.html',
  styleUrl: './request-files-upload.component.scss',
})
export class RequestFilesUploadComponent {
  UploadFileStatus = UploadFileStatus;

  title = input.required<string>();
  uploadJobRequestData = input.required<UploadDataReferenceRequestLink | null>();
  stagedUploadJobIds = input.required<string[]>();
  stagedFilesBytesSize = input.required<number>();
  filesToSubmitCount = input.required<number | null | undefined>();
  disableSubmit = input.required<boolean>();
  firmName = input.required<string>();
  userForm = input.required<FormGroup>();

  clearAllFiles = output<void>();
  submitFiles = output<void>();
}
